<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="bankInfo.BankName" label="Tên ngân hàng" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="bankInfo.BankCode" label="Tên viết tắt" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="bankInfo.Owner" label="Chủ tài khoản" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="bankInfo.CardNumber" label="Số tài khoản" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-text-field v-model="bankInfo.Branch" label="Chi nhánh" class="input-group--focused"></v-text-field>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</div>
</template>

<script>
import {
    mapState
} from "vuex";
export default {
    computed: {
        ...mapState({
            loading: state => state.bankInfo.loading,
            bankInfo: state => state.bankInfo.selected
        }),
        modifyId() {
            return this.$route.params.Pid;
        }
    },
    watch: {
        modifyId() {
            this.refreshData();
        }
    },
    methods: {
        refreshData() {
            if (this.modifyId > 0) {
                this.$store.dispatch("bankInfo/getDetail", this.modifyId);
            }
            else {
                this.$store.commit("bankInfo/setDetail", { data: {
                        ID: 0,
                        BankName: ''
                    }
                })
            }
        },
        saveData() {
            this.$store.dispatch("bankInfo/setDetail", {
                data: this.bankInfo,
                id: this.bankInfo.ID
            });
            window.getApp.$emit("APP_NAVIGATE", "BankInfoList");
        },
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>